export default __webpack_public_path__ + "static/media/clipboard-list.4be60f27.svg";